import { memo, ReactNode } from 'react';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import NextLink from 'next/link';
import Progress from '../Progress';
import { fontWeight, fontSize, borderRadius } from 'presentations/views/styles';
import Skeleton from 'presentations/views/components/atoms/Skeleton';
import {
  Appearance,
  blue01,
  gray01,
  gray04,
  gray05,
  white,
  whiteFix,
} from 'presentations/views/styles/color';

interface Props {
  size?: 'small' | 'medium' | 'large';
  type?: 'button' | 'submit';
  variant?: 'contained' | 'outlined' | 'text';
  children?: ReactNode;
  color?: 'primary' | 'secondary' | 'inherit';
  isDisabled?: boolean;
  isDisableRipple?: boolean;
  onClick?: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
  href?: any;
  className?: string;
  isLoading?: boolean;
  loadingVariant?: 'circle' | 'skeleton';
  loadingColor?: any;
  style?: any;
  dataProps?: any;
  withoutNextLink?: boolean;
}

const Component = memo((props: Props) => {
  if (props.loadingVariant === 'skeleton' && props.isLoading) {
    return <Skeleton width="100%" height={props.size === 'large' ? 50 : 42} />;
  }

  let onClick = props.onClick;
  if (props.isLoading) {
    onClick = null;
  }
  const dataProps = props.dataProps || {};
  const renderButton = (
    <StyledButton
      type={props.type || 'button'}
      size={props.size || 'medium'}
      variant={props.variant || 'contained'}
      color={props.color}
      className={props.className}
      disableElevation={true}
      disabled={props.isDisabled}
      disableRipple={props.isDisableRipple}
      onClick={onClick}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      // href={props.href}
      style={props.style}
      {...dataProps}
    >
      {props.isLoading ? <Loading size={20} color="inherit" /> : props.children}
    </StyledButton>
  );

  return typeof props.href === 'string' && !props.withoutNextLink ? (
    <NextLink href={props.href} passHref>
      {renderButton}
    </NextLink>
  ) : (
    renderButton
  );
});

const StyledButton = styled(Button)<{ variant: string; size: string }>`
  background-color: ${(props) => {
    if (props.variant === 'outlined') {
      return white;
    }
    if (!props.color) return gray05;
  }};
  color: ${(props) => {
    if (!props.color) return gray01;
  }};
  min-height: ${(props) => {
    if (props.size === 'medium') return '34px';
    else if (props.size === 'large') return '50px';
    return '34px';
  }};
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(14)};
  border-radius: ${borderRadius(6)};
  :hover {
    background-color: ${(props: any) => {
      if (props.theme.appearance === Appearance.Gray) {
        if (props.variant === 'outlined') {
          return gray01;
        }
      } else {
        if (props.variant === 'outlined') {
          return blue01;
        }
        if (!props.color) return gray04;
      }
    }};
    border-color: ${(props: any) => {
      if (props.theme.appearance === Appearance.Gray) {
        if (props.variant === 'outlined') {
          return whiteFix;
        }
      }
    }};
  }
`;

const Loading = styled(Progress)`
  /* color: white;  */
`;

export default Component;
